import type { Source } from '../api/types';

export type SourceLink = {
  label: string;
  docId: string | null;
  page: number | null;
};

type MatchableDocument = {
  id: string;
  name: string;
  sourceFileName: string | null;
};

export function buildSourceLinks(
  sources: Source[],
  documents: MatchableDocument[],
): SourceLink[] {
  const idByFileName = new Map(documents.map((doc) => [doc.sourceFileName ?? doc.name, doc.id]));

  return sources.map((source) => {
    const label = source.page != null ? `${source.document} (p.${source.page})` : source.document;
    const docId = idByFileName.get(source.document) ?? null;
    return { label, docId, page: source.page };
  });
}
